import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Component, type ErrorInfo, type ReactNode } from "react";

// eslint-disable-next-line no-restricted-imports
import App from "./App";

class RootErrorBoundary extends Component<
  { children: ReactNode },
  { error: Error | null }
> {
  state: { error: Error | null } = { error: null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error("PITALIy user screen crashed.", error, errorInfo);
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: 24, color: "#111", background: "#fff" }}>
          <strong>PITALIyを表示できませんでした</strong>
          <pre style={{ whiteSpace: "pre-wrap" }}>
            {import.meta.env.DEV
              ? this.state.error.stack || this.state.error.message
              : "画面を再読み込みしてください。"}
          </pre>
        </div>
      );
    }

    return this.props.children;
  }
}

const rootElement = document.getElementById("reco-root");
if (rootElement) {
  const app = import.meta.env.DEV ? (
    <RootErrorBoundary>
      <App />
    </RootErrorBoundary>
  ) : (
    <StrictMode>
      <RootErrorBoundary>
        <App />
      </RootErrorBoundary>
    </StrictMode>
  );

  createRoot(rootElement).render(app);
} else {
  // eslint-disable-next-line no-console
  console.error("Root element not found");
}
